(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/popupbox/assets/prescript.js') >= 0) return;  svs.modules.push('/components/components/popupbox/assets/prescript.js');

(function() {
  'use strict';

  svs.components = svs.components || {};
  svs.components.Popupbox = svs.components.Popupbox || {};
})(svs);


 })(window);